/**
 * Это общий импорт, который вытаскивает из новой либы контекст.
 * Далее по библиотеке можно было бы использовать и его.
 * Но чтобы мр не пестрил большими изменениями, в остальных случаях мы испортируем AppContext из того же места где он был и ранее.
 * Принципиальной разницы откуда выполнять импорт нет. Он все равно будет ссылаться на контекст из @centra/ui-global-context
 */
import { AppContext as GlobalAppContext } from '@centra/ui-global-context';
import { IAppContext } from './models';

export const AppContext = GlobalAppContext as unknown as React.Context<IAppContext>;
